import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { RedeploymentOrderSearchResult } from '@shared/interfaces/gridrows/redeployment-order-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { FormGroup } from '@angular/forms';
import { RedeploymentOrder } from '../../../shared/interfaces/entities/redeployment-order.interface';
import { NewOrder } from '../../../shared/interfaces/entities/new-order.interface';

@Injectable()
export class RedeploymentOrderService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) {

    //public state: State = { skip: 0, take: 100 };
  }

  getOrders(organizationId: Number | null): Observable<Array<RedeploymentOrderSearchResult>> {
    var postData: { [k: string]: any } = {};
    postData['skip'] = 0;
    postData['take'] = 100;
    postData['organizationId'] = organizationId;
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder";
    return this.http.post<Array<RedeploymentOrderSearchResult>>(url, postData);
  }

  addNewOrders(data: RedeploymentOrder): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/0";
    return this.http.post<BooleanResult>(url, data);
  }

  newOrder(data: NewOrder): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/0";
    return this.http.post<BooleanResult>(url, data);
  }

  acknowledgeTimeoutItems(): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/AcknowledgeTimeoutItems/";
    return this.http.post<BooleanResult>(url, null);
  }

  cancelOrder(id: number): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/CancelOrder/?id=" + id;
    return this.http.post<BooleanResult>(url, id);
  }

  reOpenOrder(id: number): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/ReOpenOrder/?id=" + id;
    return this.http.post<BooleanResult>(url, id);
  }

  shipOrder(id: number): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/ShipOrder/?id=" + id;
    return this.http.post<BooleanResult>(url, id);
  }

  sendCancelRequest(id: number, message: string): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/SendCancelRequest?id=" + id + "&message=" + message;
    return this.http.post<BooleanResult>(url, id);
  }

  addItemToOrder(id: number, itemUniqueIds: Array<number>, fulfillmentOrderID: number): Observable<BooleanResult> {
    var postData: any = {};
    postData['id'] = id
    postData['itemUniqueIds'] = itemUniqueIds;
    postData['fulfillmentOrderID'] = fulfillmentOrderID;

    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/AddItemOrder";
    return this.http.post<BooleanResult>(url, postData);
  }

  removeItemFromOrder(id: number, itemUniqueIds: Array<number>, fulfillmentOrderID: number): Observable<BooleanResult> {
    var postData: any = {};
    postData['id'] = id
    postData['itemUniqueIds'] = itemUniqueIds;
    postData['fulfillmentOrderID'] = fulfillmentOrderID;

    var url = this.urlHelper.getApiUrl() + "RedeploymentOrder/RemoveItemsFromOrder";
    return this.http.post<BooleanResult>(url, postData);
  }
}
